import type { Observable } from 'rxjs';

import { InjectionToken } from '@angular/core';
import { of } from 'rxjs';

export interface MustBeAuthorizedGuardConfigInterface {
  listRoles$: Observable<string[]>;
  listAuthorizedRoles: string[];
  platform: string;
  redirectUrl?: string;
}

export const MUST_BE_AUTHORIZED_GUARD_CONFIG = new InjectionToken<MustBeAuthorizedGuardConfigInterface>(
  'MustBeAuthorizedGuard Configuration',
  {
    providedIn: 'root',
    factory: () =>
      ({
        listRoles$: of(undefined),
        listAuthorizedRoles: undefined,
        platform: 'staging',
      }) as unknown as MustBeAuthorizedGuardConfigInterface,
  }
);
